import { z } from 'zod';
/** UUID (v7 preferred; any RFC 4122 accepted on input for imports). */
export const uuidSchema = z.uuid();
/** Money on the wire: canonical 4-dp decimal string + ISO code. Never a JSON number (ADR-0014). */
export const moneySchema = z.object({
    amount: z.string().regex(/^-?\d+\.\d{4}$/, 'amount must be a 4-dp decimal string'),
    currency: z.string().regex(/^[A-Z]{3}$/),
});
/** Calendar date (business dates, stay ranges) — ISO yyyy-mm-dd, no time, no zone. */
export const dateSchema = z.iso.date();
/** Idempotency-Key header value: client-generated UUID per intent (05 §5). */
export const idempotencyKeySchema = z.uuid();
/** Standard error body returned by node-api / cloud-api. */
export const apiErrorSchema = z.object({
    code: z.string(), // e.g. ROOM_NOT_READY, BALANCE_NOT_ZERO (PRD §8)
    message: z.string(),
    details: z.record(z.string(), z.unknown()).optional(),
    correlationId: z.string().optional(),
});
//# sourceMappingURL=common.js.map